import { createFileRoute } from "@tanstack/react-router";

import { AdminEarlyAccessPage } from "@/components/admin/AdminEarlyAccessPage";

export const Route = createFileRoute("/administrator/early-access")({
  head: () => ({ meta: [{ title: "Early access · GENRL Admin" }] }),
  component: AdminEarlyAccessPage,
});
